import { Injectable, signal } from '@angular/core';

import { DairyYieldScanActionPlan } from '../models/dairy-yield-scan.models';

@Injectable({ providedIn: 'root' })
export class DairyYieldScanActionPlanDraftStore {
  readonly actionPlan = signal<DairyYieldScanActionPlan | null>(null);

  setActionPlan(actionPlan: DairyYieldScanActionPlan) {
    this.actionPlan.set(actionPlan);
  }
}
